/* PLAYTS Set Showcase — add a whole pre-configured set to cart via AJAX and
 * reuse the theme's native "added to cart" modal (top-right popup with the set
 * title + View-cart / Checkout buttons). Progressive enhancement: the cart
 * button is a normal <a href> cart permalink, so if this script fails to load
 * or the theme globals are missing, the click still adds the set the old way. */
(function () {
  'use strict';

  // Idempotent: this script may be included by both the showcase section and
  // globally (for collection-tile quick-add). Bind the click listener once.
  if (window.__psAddInit) return;
  window.__psAddInit = true;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // "id:qty,id:qty" -> [{id, quantity}], merging duplicate variants.
  function parseItems(str) {
    var map = {};
    (str || '').split(',').forEach(function (tok) {
      var parts = tok.split(':');
      var id = parseInt(parts[0], 10);
      var qty = parseInt(parts[1], 10) || 1;
      if (!id) return;
      map[id] = (map[id] || 0) + qty;
    });
    return Object.keys(map).map(function (id) { return { id: Number(id), quantity: map[id] }; });
  }

  function addUrl() {
    var base = (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add';
    return base + '.js';
  }
  function cartUrl() {
    return (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
  }

  function refreshHeaderCart() {
    // Mirror the theme's own post-add refresh so the header cart bubble updates.
    try {
      fetch(cartUrl(), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (data) {
          var sel = '#site-control .cart:not(.nav-search), [data-section-type="cart-template"]';
          var doc = new DOMParser().parseFromString(data, 'text/html');
          var fresh = doc.querySelectorAll(sel);
          var current = document.querySelectorAll(sel);
          current.forEach(function (el, i) { if (fresh[i]) el.replaceWith(fresh[i]); });
        }).catch(function () {});
    } catch (e) { /* header just updates on next load */ }
  }

  function showModal(btn) {
    var title = btn.getAttribute('data-ps-title') || '';
    var img = btn.getAttribute('data-ps-image') || '';
    var now = btn.getAttribute('data-ps-price') || '';
    var was = btn.getAttribute('data-ps-price-was') || '';
    var toCart = btn.getAttribute('data-ps-cart-url') || cartUrl();
    var toCheckout = btn.getAttribute('data-ps-checkout-url') || '/checkout';

    var tick = (window.theme && theme.icons && theme.icons.tick) || '';
    var s = (window.theme && theme.strings) || {};
    var added = s.productAddedToCart || 'Zum Warenkorb hinzugefügt';
    var viewCart = s.viewCart || 'Warenkorb';
    var checkout = s.popupCheckout || 'Zur Kasse';

    var offset = 25;
    try {
      var nav = theme.Nav();
      if (nav && nav.bar && nav.bar.getPositionSetting() !== 'inline') { offset = nav.bar.height(); }
    } catch (e) {}

    var priceHtml = now
      ? '<p class="cart-product__content__price">' +
          (was ? '<s>' + esc(was) + '</s> ' : '') + esc(now) +
        '</p>'
      : '';

    var html =
      '<div id="added-to-cart" class="theme-modal theme-modal--small" role="dialog" aria-modal="true" aria-labelledby="added-to-cart-title">' +
        '<div class="inner" style="top:' + offset + 'px">' +
          '<a href="#" data-modal-close class="modal-close">&times;</a>' +
          '<h4 id="added-to-cart-title">' + tick + esc(added) + '</h4>' +
          '<div class="cart-product">' +
            (img ? '<div class="cart-product__image"><img src="' + esc(img) + '" alt=""/></div>' : '') +
            '<div class="cart-product__content">' +
              '<p class="cart-product__content__title">' + esc(title) + '</p>' +
              priceHtml +
            '</div>' +
          '</div>' +
          '<p class="links">' +
            '<a href="' + esc(toCart) + '" class="button alt">' + esc(viewCart) + '</a>' +
            '<a href="' + esc(toCheckout) + '" class="button button--checkout">' + esc(checkout) + '</a>' +
          '</p>' +
        '</div>' +
      '</div>';

    window.showThemeModal(html, 'added-to-cart', null);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ps-add]');
    if (!btn) return;

    // No native modal available (theme not ready) → let the permalink href run.
    if (typeof window.showThemeModal !== 'function') return;

    var items = parseItems(btn.getAttribute('data-ps-add'));
    if (!items.length) return;

    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    fetch(addUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      })
      .then(function () {
        showModal(btn);
        refreshHeaderCart();
      })
      .catch(function (err) {
        console.error('PLAYTS showcase: add-to-cart failed', err);
        // Fall back to the cart permalink (also applies the discount).
        var href = btn.getAttribute('href');
        if (href) window.location = href;
      })
      .then(function () { btn.classList.remove('is-loading'); });
  });

  // Show-more: reveal the collapsed cards (staggered fade-in), drop the button.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ps-more]');
    if (!btn) return;
    var root = btn.closest('[data-ps-root]') || document;
    var cards = root.querySelectorAll('.playts-showcase__card.is-collapsed');
    Array.prototype.forEach.call(cards, function (card, i) {
      card.style.animationDelay = Math.min(i * 45, 400) + 'ms';
      card.classList.remove('is-collapsed');
      card.classList.add('is-revealed');
    });
    var row = btn.closest('.playts-showcase__more-row');
    if (row) row.remove();
  });
})();
